











export default {
  name: 'RespondecoFilterToggle',

  props: {
    name: String,
  },
}
